import React from 'react';
import {FaBars, FaAngleDoubleLeft, FaAngleDoubleRight} from "react-icons/fa"
import Popper from '@material-ui/core/Popper';
import { motion } from "framer-motion"

import { Button } from 'components'
import { Side } from 'features';


import classes from './Toggle.module.css'
import { sideContext } from 'context'

const Toggle = props => {
    const {
        side,
        toggleHandler
    } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, openPopper] = React.useState(false)
    const clickHandler = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        openPopper(!open);
    }

    const SidePopOutHandler = (event) => {
        toggleHandler(sideContext.TYPES.POPOUT);
        clickHandler(event)
    }

    const hoverHandler = (event) => {
        toggleHandler(sideContext.TYPES.CLOSED)
        clickHandler(event)
    }

    return (
        <div>
            {side === sideContext.TYPES.OPENED ?  <FaAngleDoubleLeft className={classes.Toggle} onClick={() => toggleHandler('Closed')}/>
            : side === sideContext.TYPES.CLOSED ? <FaBars className={classes.Toggle} onMouseEnter={SidePopOutHandler} onClick={() => toggleHandler('PopOut')}/>
            : side === sideContext.TYPES.POPOUT ? <FaAngleDoubleRight className={classes.Toggle} onClick={() => toggleHandler('Opened')}/>
            : <FaAngleDoubleLeft className={classes.Toggle} onClick={() => toggleHandler('Closed')}/>
            }

            {side === sideContext.TYPES.POPOUT ? 
            <motion.div size='100%' position="absolute" background='transparent' style={{position: 'absolute', zIndex: 1300, left: 0}}
                positionTransition
                initial="collapsed"
                animate="open"
                exit="collapsed"
                variants={{
                    open: {x: 0, width: 'auto'},
                    collapsed: {x: '-15rem', width: 0}
                }}
                transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
                >
                <Side type={sideContext.TYPES.POPOUT}/>
            </motion.div> : null}
            {side === sideContext.TYPES.POPOUT ? <div className={classes.CloseContainer} onClick={hoverHandler} onMouseEnter={hoverHandler} onMouseOver={hoverHandler}></div> : null}
        </div>
    )
}



export default Toggle;
